export var WorkshopLocation;
(function (WorkshopLocation) {
    WorkshopLocation[WorkshopLocation["Zwolle"] = 1] = "Zwolle";
    WorkshopLocation[WorkshopLocation["Emmeloord"] = 2] = "Emmeloord";
    WorkshopLocation[WorkshopLocation["Apeldoorn"] = 3] = "Apeldoorn";
    WorkshopLocation[WorkshopLocation["Enschede"] = 4] = "Enschede";
})(WorkshopLocation || (WorkshopLocation = {}));
export const WorkshopLocationMap = new Map([
    [WorkshopLocation.Zwolle, 'Zwolle'],
    [WorkshopLocation.Emmeloord, 'Emmeloord'],
    [WorkshopLocation.Apeldoorn, 'Apeldoorn'],
    [WorkshopLocation.Enschede, 'Enschede']
]);
